import React from 'react';
import { Table, Button } from 'semantic-ui-react';


const PremisesTable = ({
    rooms, activateEditRequest, writePrivilege, switchToDetails, getSortedRooms, fieldName, direction
}) => (
    <Table celled selectable sortable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell
                    sorted={fieldName === 'name' ? direction : null}
                    onClick={() => getSortedRooms('name')}
                >Naziv</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'code' ? direction : null}
                    onClick={() => getSortedRooms('code')}
                >Kod</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'roomType' ? direction : null}
                    onClick={() => getSortedRooms('roomType', 'name')}
                >Tip</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'floor' ? direction : null}
                    onClick={() => getSortedRooms('floor')}
                >Sprat</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'area' ? direction : null}
                    onClick={() => getSortedRooms('area')}
                >Površina (m<sup>2</sup>)</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'disabledAccess' ? direction : null}
                    onClick={() => getSortedRooms('disabledAccess', 'name')}
                >Pristup invalidima</Table.HeaderCell>

                {writePrivilege &&
                <Table.HeaderCell></Table.HeaderCell>
                }
            </Table.Row>
        </Table.Header>

        <Table.Body>
            {rooms.map(el =>
                (
                    <Table.Row key={el.id}>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.name}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.code}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{!!el.roomType && el.roomType.name}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.floor}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.area}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{!!el.disabledAccess && el.disabledAccess.name}</Table.Cell>

                        {writePrivilege &&
                        <Table.Cell verticalAlign="middle" className="text-center" >
                            <Button
                                basic
                                color="green"
                                size="small"
                                onClick={() => activateEditRequest(el)}
                            >
                                Uredi
                            </Button>
                        </Table.Cell>
                        }
                    </Table.Row>
                ))
            }
        </Table.Body>
    </Table>);

export default PremisesTable;



// WEBPACK FOOTER //
// ./src/views/Assets/Premises/PremisesTable.js